export const CalculateSine = (start: number, end: number, step: number): number[] => {
  const 
    median = start === end ? Math.max(start, end) : Math.floor(((end - start) * 50 / 100 + start)),
    theta = 90 / Math.floor(step / 2),
    thetaList = [];
  for(let count = 1; count < Math.floor(step / 2); count++) {
    thetaList.push(Math.sin((theta * count) * (Math.PI / 180)));
  }
  const startList = thetaList.map((theta) => {
    if(start < end) {
      return median < start + Math.round(median * theta) ? median : start + Math.round(median * theta);
    } else {
      return median < start - Math.round(median * theta) ? start - Math.round(median * theta) : median;
    }
  });
  const endList = thetaList.slice(0).reverse().map((theta) => {
    if(start < end) {
      return median < end - Math.round(median * theta) ? end - Math.round(median * theta) : median;
    } else {
      return median < end + Math.round(median * theta) ? median : end + Math.round(median * theta);
    }
  });
  return step % 2 === 0 ? [start, ...startList, ...endList, end] : [start, ...startList, median, ...endList, end]; 
}